module.exports = __webpack_public_path__ + "img/web_pic1_v2.6831a365.png";